


import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageProvider";




export default function DatenschutzPage({ showBackButton = false, onBack = null }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useLanguage();

const handleBack = () => {
  if (typeof onBack === "function") {
    onBack();
    return;
  }
  if (location.state?.from === "landing") {
    navigate("/landing");
    return;
  }
  if (
    typeof window !== "undefined" &&
    window.sessionStorage?.getItem("vaultquest:returnToRegister") === "1"
  ) {
    navigate("/login");
    return;
  }
  navigate("/");
};

  return (
  <div
    style={{
      width: "92%",
      margin: "0 auto",
      padding: "calc(18px + var(--vq-safe-area-top)) calc(16px + var(--vq-safe-area-right)) calc(28px + var(--vq-safe-area-bottom)) calc(16px + var(--vq-safe-area-left))",
      borderRadius: "16px",
      background: "rgba(255,255,255,0.04)",
      border: "1px solid rgba(255,255,255,0.10)",
      color: "white",
      boxSizing: "border-box",
    }}
  >
       {showBackButton && (
  <button
    onClick={handleBack}
    style={{
      background: "transparent",
      border: "1px solid rgba(255,255,255,0.2)",
      color: "#fff",
      padding: "10px 16px",
      borderRadius: "10px",
      cursor: "pointer",
      marginBottom: "30px",
      fontSize: "15px",
    }}
  >
    ← {t("common.back")}
  </button>
)} 
       <h1 style={{ marginTop: 0, fontSize: "clamp(22px, 5vw, 28px)", fontWeight: "800", marginBottom: "24px", lineHeight: 1.2 }}>
  {t("privacy.title")}
</h1>

       <h2 style={styles.h2}>{t("privacy.section1Title")}</h2>

<p style={styles.p}>{t("privacy.section1Text1")}</p>
<p style={styles.p}>{t("privacy.section1Text2")}</p>
<p style={styles.p}>{t("privacy.section1Text3")}</p>

      <h2 style={styles.h2}>{t("privacy.section2Title")}</h2>
<p style={styles.p}>{t("privacy.section2Text1")}</p>
<p style={styles.p}>
  {t("privacy.controllerName")}
  <br />
  {t("privacy.controllerStreet")}
  <br />
  {t("privacy.controllerCity")}
  <br />
  {t("privacy.controllerCountry")}
  <br />
  {t("privacy.controllerEmailLabel")}: {t("privacy.controllerEmail")}
</p> 

       <h2 style={styles.h2}>{t("privacy.section3Title")}</h2>

<p style={styles.p}>{t("privacy.section3Text1")}</p>

<p style={styles.p}>{t("privacy.section3Text2")}</p>

<ul style={styles.ul}>
  <li>{t("privacy.section3List1")}</li>
  <li>{t("privacy.section3List2")}</li>
  <li>{t("privacy.section3List3")}</li>
  <li>{t("privacy.section3List4")}</li>
  <li>{t("privacy.section3List5")}</li>
  <li>{t("privacy.section3List6")}</li>
</ul> 

    <h2 style={styles.h2}>{t("privacy.section4Title")}</h2>

<h3 style={styles.h3}>{t("privacy.section41Title")}</h3>

<p style={styles.p}>
  {t("privacy.section41Text1")}
</p>

<ul style={styles.ul}>
  <li>{t("privacy.section41List1")}</li>
  <li>{t("privacy.section41List2")}</li>
  <li>{t("privacy.section41List3")}</li>
  <li>{t("privacy.section41List4")}</li>
  <li>{t("privacy.section41List5")}</li>
  <li>{t("privacy.section41List6")}</li>
  <li>{t("privacy.section41List7")}</li>
  <li>{t("privacy.section41List8")}</li>
  <li>{t("privacy.section41List9")}</li>
  <li>{t("privacy.section41List10")}</li>
  <li>{t("privacy.section41List11")}</li>
</ul>   

<h3 style={styles.h3}>{t("privacy.section42Title")}</h3>

<p style={styles.p}>
  {t("privacy.section42Text1")}
</p>

<ul style={styles.ul}>
  <li>{t("privacy.section42List1")}</li>
  <li>{t("privacy.section42List2")}</li>
  <li>{t("privacy.section42List3")}</li>
  <li>{t("privacy.section42List4")}</li>
  <li>{t("privacy.section42List5")}</li>
  <li>{t("privacy.section42List6")}</li>
  <li>{t("privacy.section42List7")}</li>
  <li>{t("privacy.section42List8")}</li>
  <li>{t("privacy.section42List9")}</li>
</ul>

<p style={styles.p}>
  {t("privacy.section42Text2")}
</p>

<h3 style={styles.h3}>{t("privacy.section43Title")}</h3>

<p style={styles.p}>
  {t("privacy.section43Text1")}
</p>

<ul style={styles.ul}>
  <li>{t("privacy.section43List1")}</li>
  <li>{t("privacy.section43List2")}</li>
  <li>{t("privacy.section43List3")}</li>
  <li>{t("privacy.section43List4")}</li>
  <li>{t("privacy.section43List5")}</li>
  <li>{t("privacy.section43List6")}</li>
  <li>{t("privacy.section43List7")}</li>
  <li>{t("privacy.section43List8")}</li>
  <li>{t("privacy.section43List9")}</li>
  <li>{t("privacy.section43List10")}</li>
  <li>{t("privacy.section43List11")}</li>
</ul>

    <h2 style={styles.h2}>{t("privacy.section5Title")}</h2>

<p style={styles.p}>
  {t("privacy.section5Text1")}
</p>

<ul style={styles.ul}>
  <li>{t("privacy.section5List1")}</li>
  <li>{t("privacy.section5List2")}</li>
  <li>{t("privacy.section5List3")}</li>
  <li>{t("privacy.section5List4")}</li>
  <li>{t("privacy.section5List5")}</li>
  <li>{t("privacy.section5List6")}</li>
  <li>{t("privacy.section5List7")}</li>
  <li>{t("privacy.section5List8")}</li>
  <li>{t("privacy.section5List9")}</li>
  <li>{t("privacy.section5List10")}</li>
  <li>{t("privacy.section5List11")}</li>
<li>{t("privacy.section5List12")}</li>
</ul>   

    <h2 style={styles.h2}>{t("privacy.section6Title")}</h2>

<p style={styles.p}>
  {t("privacy.section6Text1")}
</p>

<h3 style={styles.h3}>{t("privacy.section6Sub1Title")}</h3>
<p style={styles.p}>
  {t("privacy.section6Sub1Text")}
</p>

<h3 style={styles.h3}>{t("privacy.section6Sub2Title")}</h3>
<p style={styles.p}>
  {t("privacy.section6Sub2Text")}
</p>

<h3 style={styles.h3}>{t("privacy.section6Sub3Title")}</h3>
<p style={styles.p}>
  {t("privacy.section6Sub3Text")}
</p>

<h3 style={styles.h3}>{t("privacy.section6Sub4Title")}</h3>
<p style={styles.p}>
  {t("privacy.section6Sub4Text")}
</p>  

    <h2 style={styles.h2}>{t("privacy.section7Title")}</h2>

<p style={styles.p}>
  {t("privacy.section7Text1")}
</p>

<ul style={styles.ul}>
  <li>{t("privacy.section7List1")}</li>
  <li>{t("privacy.section7List2")}</li>
  <li>{t("privacy.section7List3")}</li>
  <li>{t("privacy.section7List4")}</li>
  <li>{t("privacy.section7List5")}</li>
  <li>{t("privacy.section7List6")}</li>
</ul>

<p style={styles.p}>
  {t("privacy.section7Text2")}
</p>

<h2 style={styles.h2}>{t("privacy.section8Title")}</h2>

<p style={styles.p}>
  {t("privacy.section8Text1")}
</p>

<ul style={styles.ul}>
  <li>{t("privacy.section8List1")}</li>
  <li>{t("privacy.section8List2")}</li>
  <li>{t("privacy.section8List3")}</li>
  <li>{t("privacy.section8List4")}</li>
  <li>{t("privacy.section8List5")}</li>
  <li>{t("privacy.section8List6")}</li>
  <li>{t("privacy.section8List7")}</li>
  <li>{t("privacy.section8List8")}</li>
</ul>

<p style={styles.p}>
  {t("privacy.section8Text2")}
</p>

<p style={styles.p}>
  {t("privacy.section8Text3")}
</p>

<h2 style={styles.h2}>{t("privacy.section9Title")}</h2>

<p style={styles.p}>
  {t("privacy.section9Text1")}
</p>

<ul style={styles.ul}>
  <li>{t("privacy.section9List1")}</li>
  <li>{t("privacy.section9List2")}</li>
  <li>{t("privacy.section9List3")}</li>
  <li>{t("privacy.section9List4")}</li>
  <li>{t("privacy.section9List5")}</li>
  <li>{t("privacy.section9List6")}</li>
</ul>

<p style={styles.p}>
  {t("privacy.section9Text2")}
</p>

<p style={styles.p}>
  {t("privacy.section9Text3")}
</p>

<p style={styles.p}>
  {t("privacy.section9Text4")}
</p>

<h3 style={styles.h3}>{t("privacy.section91Title")}</h3>

<p style={styles.p}>
  {t("privacy.section91Text1")}
</p>

<ul style={styles.ul}>
  <li>{t("privacy.section91List1")}</li>
  <li>{t("privacy.section91List2")}</li>
  <li>{t("privacy.section91List3")}</li>
  <li>{t("privacy.section91List4")}</li>
  <li>{t("privacy.section91List5")}</li>
  <li>{t("privacy.section91List6")}</li>
  <li>{t("privacy.section91List7")}</li>
</ul>

<p style={styles.p}>
  {t("privacy.section91Text2")}
</p>

<p style={styles.p}>
  {t("privacy.section91Text3")}
</p>

<p style={styles.p}>
  {t("privacy.section91Text4")}
</p>

<p style={styles.p}>
  {t("privacy.section91Text5")}
</p>

<p style={styles.p}>
  {t("privacy.section91Text6")}
</p>

<p style={styles.p}>
  {t("privacy.section91TextConsent")}
</p>

<p style={styles.p}>
  {t("privacy.section91Text7")}
</p>

<p style={styles.p}>
  {t("privacy.section91Text8")}
</p>

<p style={styles.p}>
  {t("privacy.section91Text9")}
</p>

    <h2 style={styles.h2}>{t("privacy.section10Title")}</h2>

<p style={styles.p}>
  {t("privacy.section10Text1")}
</p>

<p style={styles.p}>
  {t("privacy.section10Text2")}
</p>

<ul style={styles.ul}>
  <li>{t("privacy.section10List1")}</li>
  <li>{t("privacy.section10List2")}</li>
  <li>{t("privacy.section10List3")}</li>
  <li>{t("privacy.section10List4")}</li>
  <li>{t("privacy.section10List5")}</li>
</ul>

<p style={styles.p}>
  {t("privacy.section10Text3")}
</p> 

<h2 style={styles.h2}>{t("privacy.section11Title")}</h2>

<p style={styles.p}>
  {t("privacy.section11Text1")}
</p>

<ul style={styles.ul}>
  <li>{t("privacy.section11List1")}</li>
  <li>{t("privacy.section11List2")}</li>
  <li>{t("privacy.section11List3")}</li>
  <li>{t("privacy.section11List4")}</li>
  <li>{t("privacy.section11List5")}</li>
</ul>

<p style={styles.p}>
  {t("privacy.section11Text2")}
</p>


<h2 style={styles.h2}>{t("privacy.section12Title")}</h2>

<p style={styles.p}>
  {t("privacy.section12Text1")}
</p>

<p style={styles.p}>
  {t("privacy.section12Text2")}
</p>

<ul style={styles.ul}>
  <li>{t("privacy.section12List1")}</li>
  <li>{t("privacy.section12List2")}</li>
  <li>{t("privacy.section12List3")}</li>
  <li>{t("privacy.section12List4")}</li>
</ul>

<p style={styles.p}>
  {t("privacy.section12Text3")}
</p>

<ul style={styles.ul}>
  <li>{t("privacy.section12PurposeList1")}</li>
  <li>{t("privacy.section12PurposeList2")}</li>
  <li>{t("privacy.section12PurposeList3")}</li>
  <li>{t("privacy.section12PurposeList4")}</li>
  <li>{t("privacy.section12PurposeList5")}</li>
  <li>{t("privacy.section12PurposeList6")}</li>
  <li>{t("privacy.section12PurposeList7")}</li>
</ul>

<p style={styles.p}>
  {t("privacy.section12Text4")}
</p>

<h2 style={styles.h2}>{t("privacy.section13Title")}</h2>

<p style={styles.p}>
  {t("privacy.section13Text1")}
</p>

<ul style={styles.ul}>
  <li>{t("privacy.section13List1")}</li>
  <li>{t("privacy.section13List2")}</li>
  <li>{t("privacy.section13List3")}</li>
  <li>{t("privacy.section13List4")}</li>
  <li>{t("privacy.section13List5")}</li>
  <li>{t("privacy.section13List6")}</li>
</ul>

<p style={styles.p}>
  {t("privacy.section13Text2")}
</p>


<h2 style={styles.h2}>{t("privacy.section14Title")}</h2>

<p style={styles.p}>
  {t("privacy.section14Text1")}
</p>

<p style={styles.p}>
  {t("privacy.section14Text2")}
</p>

<p style={styles.p}>
  {t("privacy.section14Text3")}
</p>

<h2 style={styles.h2}>{t("privacy.section15Title")}</h2>

<p style={styles.p}>
  {t("privacy.section15Text1")}
</p>

<p style={styles.p}>
  {t("privacy.section15Text2")}
</p>

<ul style={styles.ul}>
  <li>{t("privacy.section15List1")}</li>
  <li>{t("privacy.section15List2")}</li>
  <li>{t("privacy.section15List3")}</li>
  <li>{t("privacy.section15List4")}</li>
  <li>{t("privacy.section15List5")}</li>
</ul>

<p style={styles.p}>
  {t("privacy.section15Text3")}
</p>

<p style={styles.p}>
  {t("privacy.section15Text4")}
</p>


<h2 style={styles.h2}>{t("privacy.section16Title")}</h2>

<p style={styles.p}>
  {t("privacy.section16Text1")}
</p>

<ul style={styles.ul}>
  <li>{t("privacy.section16List1")}</li>
  <li>{t("privacy.section16List2")}</li>
  <li>{t("privacy.section16List3")}</li>
  <li>{t("privacy.section16List4")}</li>
  <li>{t("privacy.section16List5")}</li>
  <li>{t("privacy.section16List6")}</li>
</ul>

<p style={styles.p}>
  {t("privacy.section16Text2")}
</p>

<p style={styles.p}>
  {t("privacy.section16Text3")}
</p>

<h2 style={styles.h2}>{t("privacy.section17Title")}</h2>

<p style={styles.p}>
  {t("privacy.section17Text1")}
</p>

<p style={styles.p}>{t("privacy.section17Text2")}</p>

<ul style={styles.ul}>
  <li>{t("privacy.section17List1")}</li>
  <li>{t("privacy.section17List2")}</li>
  <li>{t("privacy.section17List3")}</li>
  <li>{t("privacy.section17List4")}</li>
  <li>{t("privacy.section17List5")}</li>
</ul>

<p style={styles.p}>
  {t("privacy.section17Text3")}
</p>

<p style={styles.p}>
  {t("privacy.section17Text4")}
</p>

<p style={styles.p}>
  {t("privacy.section17Text5")}
</p>

<p style={styles.p}>
  {t("privacy.section17Text6")}
</p>

<h2 style={styles.h2}>{t("privacy.section18Title")}</h2>

<p style={styles.p}>
  {t("privacy.section18Text1")}
</p>

<ul style={styles.ul}>
  <li>{t("privacy.section18List1")}</li>
  <li>{t("privacy.section18List2")}</li>
  <li>{t("privacy.section18List3")}</li>
  <li>{t("privacy.section18List4")}</li>
  <li>{t("privacy.section18List5")}</li>
  <li>{t("privacy.section18List6")}</li>
  <li>{t("privacy.section18List7")}</li>
  <li>{t("privacy.section18List8")}</li>
</ul>

<p style={styles.p}>
  {t("privacy.section18Text2")} {t("privacy.controllerEmail")}
</p>




<h2 style={styles.h2}>{t("privacy.section19Title")}</h2>

<p style={styles.p}>
  {t("privacy.section19Text1")}
</p>

<p style={styles.p}>
  {t("privacy.section19Text2")}
</p>

<h2 style={styles.h2}>{t("privacy.section20Title")}</h2>

<p style={styles.p}>
  {t("privacy.section20Text1")}
</p>

<p style={styles.p}>{t("privacy.section20Text2")}</p>

<ul style={styles.ul}>
  <li>{t("privacy.section20List1")}</li>
  <li>{t("privacy.section20List2")}</li>
  <li>{t("privacy.section20List3")}</li>
  <li>{t("privacy.section20List4")}</li>
  <li>{t("privacy.section20List5")}</li>
</ul>

<p style={styles.p}>
  {t("privacy.section20Text3")}
</p>

<h2 style={styles.h2}>{t("privacy.section21Title")}</h2>

<p style={styles.p}>
  {t("privacy.section21Text1")}
</p>

<p style={styles.p}>
  {t("privacy.section21Text2")}
</p>

<p style={styles.p}>
  {t("privacy.section21Text3")}
</p>















      </div>
    
  );
}

const styles = {
  h2: {
    fontSize: "26px",
    fontWeight: "700",
    marginTop: "30px",
    marginBottom: "12px",
  },
  h3: {
    fontSize: "20px",
    fontWeight: "700",
    marginTop: "20px",
    marginBottom: "10px",
  },
  p: {
    fontSize: "18px",
    lineHeight: "1.7",
    color: "rgba(255,255,255,0.9)",
    marginBottom: "16px",
  },
  ul: {
    paddingLeft: "22px",
    lineHeight: "1.8",
    fontSize: "18px",
    color: "rgba(255,255,255,0.9)",
    marginBottom: "16px",
  },
};
